/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { AllFormsUpperphoto, Applogo, avatar1, avatar13, avatar16, avatar18, avatar19, avatar2, avatar20, avatar21, avatar23, avatar26, avatar4, avatar6, avatar8, clockin, employeeimg, holidaycalendar } from "../../../../../Routes/ImagePath";
import Chart from "react-apexcharts";
import Slider from "react-slick";
import { ArrowRightCircle } from "react-feather";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Api_Url } from "../../../../../config/config";
import axios from "axios";
import "./EmployeeDashboard.css"

import employee from "../../../../../assets/img/avatar/DirectorImage.png"
import moment from "moment";
import { ActivityData } from "../../../../../Data/AllactivityJson";

const EmployeeDashboard = () => {
  const tooltip = (
    <Tooltip id="tooltip-id">
      Lesley Grauer
    </Tooltip>
  );
  const tooltip1 = (
    <Tooltip id="tooltip-id">
      Richard Miles
    </Tooltip>
  );
  const tooltip2 = (
    <Tooltip id="tooltip-id">
      Loren Gatlin
    </Tooltip>
  );
  const tooltip3 = (
    <Tooltip id="tooltip-id">
      Jeffery Lalor
    </Tooltip>
  );
  const tooltip4 = (
    <Tooltip id="tooltip-id">
      Tarah Shropshire
    </Tooltip>
  );
  const tooltip5 = (
    <Tooltip id="tooltip-id">
      Catherine Manseau
    </Tooltip>
  );
  const tooltip6 = (
    <Tooltip id="tooltip-id">
      Richard Miles
    </Tooltip>
  );
  const tooltip7 = (
    <Tooltip id="tooltip-id">
      Jeffery Lalor
    </Tooltip>
  );
  const tooltip8 = (
    <Tooltip id="tooltip-id">
      Lesley Grauer
    </Tooltip>
  );
  const tooltip9 = (
    <Tooltip id="tooltip-id">
      Loren Gatlin
    </Tooltip>
  );
  const tooltip10 = (
    <Tooltip id="tooltip-id">
      Tarah Shropshire
    </Tooltip>
  );
  const tooltip11 = (
    <Tooltip id="tooltip-id">
      John Smith"
    </Tooltip>
  );
  const tooltip12 = (
    <Tooltip id="tooltip-id">
      Richard Miles
    </Tooltip>
  );
  const tooltip13 = (
    <Tooltip id="tooltip-id">
      Jeffery Lalor
    </Tooltip>
  );
  const tooltip14 = (
    <Tooltip id="tooltip-id">
      Lesley Grauer
    </Tooltip>
  );
  const tooltip15 = (
    <Tooltip id="tooltip-id">
      Tarah Shropshire
    </Tooltip>
  );
  const tooltip16 = (
    <Tooltip id="tooltip-id">
      Loren Gatlin
    </Tooltip>
  );
  // const [menu, setMenu] = useState(false);

  // const toggleMobileMenu = () => {
  //   setMenu(!menu);
  // };
  const [chartOptions] = useState({
    series: [
      {
        name: "Sales",
        data: [-50, -120, -80, -180, -80, -70, -100],
      },
      {
        name: "Purchase",
        data: [200, 250, 200, 290, 220, 300, 250],
      },
    ],
    colors: ['#FC133D', '#55CE63'],
    chart: {
      type: 'bar',
      height: 210,
      stacked: true,

      zoom: {
        enabled: true
      }
    },
    responsive: [
      {
        breakpoint: 280,
        options: {
          legend: {
            position: "bottom",
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 6,
        borderRadiusApplication: "end", // "around" / "end" 
        borderRadiusWhenStacked: "all", // "all"/"last"
        columnWidth: '30%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      min: -200,
      max: 300,
      tickAmount: 5,
    },
    xaxis: {
      categories: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S",

      ],
    },
    legend: { show: false },
    fill: {
      opacity: 1,
    },
  });
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    marginrigth: 10,
  };
  const settingsprojectslide = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,

  };



  const name = JSON.parse(sessionStorage.getItem('user'))?.fullName

  const PunchIn = false

  const dailyQuote = {
    id: 1,
    quote: "Teamwork is the ability to work together toward a common vision. The ability to direct individual accomplishments toward organizational objectives. It is the fuel that allows common people to attain uncommon results.",
   
  }



  const [userProfileImage, setuserProfileImage] = useState(null)



  const FetchImage = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem('user'));
      
      // Check if user data exists and has an id
      if (user?.id && user.accessToken) {
        const response = await axios.get(`${Api_Url}api/v1/UserProfile/${user.id}`, {
          headers: {
            'Authorization': `Bearer ${user.accessToken}`
          }
        });
        
        console.log("MY Data", response)
        if (response.data?.data) {
          
          setuserProfileImage(response?.data?.data); // Set the profile image data
          sessionStorage.setItem("profile", JSON.stringify(response.data.data)); // Store profile data in sessionStorage
        } else {
          console.warn("Profile data not found");
        }
      } else {
        console.warn("User data not found in session storage");
      }
    } catch (error) {
      console.error("Error fetching profile image:", error);
    }
  };
  
  useEffect(() => {

    FetchImage()
  }, [])

  const [isPunchedIn, setisPunchedIn] = useState(false)
  const [isPunchedOut, setisPunchedOut] = useState(false)
  const [showRemainingTime, setShowRemainingTime] = useState(true);
  // const [isButtonDisabled, setisButtonDisabled] = useState(false)
  const [punchedUser, setPunchedUser] = useState({
    PunchInLongitude: "",
    punchOutLongitude: "",
    PunchInLatitude: "",
    PunchOutLatitude: "",
    BranchId: Number,
    ShiftId: Number,
    UserProfileId: Number
  })



  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setPunchedUser((prevState) => ({
          ...prevState,
          PunchInLatitude: latitude.toString(),
          PunchInLongitude: longitude.toString(),
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);


  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setPunchedUser((prevState) => ({
          ...prevState,
          PunchOutLatitude: latitude.toString(),
          PunchOutLongitude: longitude.toString(),
        }));
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }, []);

  const HandlePunchIn = async () => {


    if (!isPunchedIn) {
      const formdata = new FormData();
      formdata.append("PunchInLatitude", punchedUser.PunchInLatitude)
      formdata.append("PunchInLongitude", punchedUser.PunchInLongitude)
      formdata.append("BranchId", JSON.parse(sessionStorage.getItem('profile'))?.branchId)
      formdata.append("ShiftId", JSON.parse(sessionStorage.getItem('profile'))?.shiftId)
      formdata.append("UserProfileId", JSON.parse(sessionStorage.getItem('user'))?.id)

      try {
        const id = JSON.parse(sessionStorage.getItem('user'))?.id
        const response = await axios.post(`${Api_Url}api/v1/Attendance/punchin/${id}`, formdata, {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
            'Content-Type': 'multipart/form-data'
          }
        })
        if (response.data.succeeded) {
          AllActivityFetch()
          setisPunchedIn(true)
          TodayPunchedIn()
        }
        // 
      } catch (error) {
        return error.message
      }
    } else {
      const formdata = new FormData();
      formdata.append("punchOutLatitude", punchedUser.PunchOutLatitude)
      formdata.append("PunchOutLongitude", punchedUser.punchOutLongitude)
      formdata.append("BranchId", JSON.parse(sessionStorage.getItem('profile'))?.branchId)
      formdata.append("ShiftId", JSON.parse(sessionStorage.getItem('profile'))?.shiftId)
      formdata.append("UserProfileId", JSON.parse(sessionStorage.getItem('user'))?.id)

      try {
        const id = JSON.parse(sessionStorage.getItem('user'))?.id
        const response = await axios.post(`${Api_Url}api/v1/Attendance/punchout/${id}`, formdata, {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
            'Content-Type': 'multipart/form-data'
          }
        })
        TodayPunchedIn()
        // if (response.data?.succeeded === true) {
        // setisButtonDisabled(true)
        // }

      } catch (error) {
        return error
      }
    }
  }

  const [readmore, setReadMore] = useState(false)
  const readmoreButton = () => {
    setReadMore(!readmore)
  }


  const [workTime, setWorkTime] = useState('');

  const [remainingTime, setRemainingTime] = useState(null)


  const calculateTimeDifference = (punchIn, punchOut) => {
    const punchInDate = new Date(punchIn);
    const punchOutDate = new Date(punchOut);

    const differenceInMillis = punchOutDate - punchInDate;
    let differenceInMinutes = Math.floor(differenceInMillis / (1000 * 60));


    const differenceInHours = Math.floor(differenceInMinutes / 60);
    const remainingMinutes = differenceInMinutes % 60;

    return `${differenceInHours} hours : ${remainingMinutes} minutes`;
  };


  const [isUserPunchedIn, setIsUserPunchedIn] = useState(null)
  const [overtime, setOverTime] = useState(null)

  const TodayPunchedIn = async () => {
    try {
      const id = JSON.parse(sessionStorage.getItem('user'))?.id;
      const response = await axios.get(`${Api_Url}api/v1/Attendance/today-attendance/${id}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
        },
      });
      setIsUserPunchedIn(response.data?.data?.punchIn)
      const punchInTime = response.data?.data?.punchIn;
      const punchOutTime = response.data?.data?.punchOut;

      const currentTime = new Date();
      const targetTime = new Date();
      targetTime.setHours(19, 0, 0, 0);

      const timeDiff = targetTime - currentTime;

      const seconds = Math.floor(timeDiff / 1000) % 60;
      const minutes = Math.floor(timeDiff / (1000 * 60)) % 60;
      const hours = Math.floor(timeDiff / (1000 * 60 * 60));

      const punchOutDate = new Date(punchOutTime)
      const OverTimeWork = punchOutDate - targetTime;

      const second = Math.floor(OverTimeWork / 1000) % 60;
      const minute = Math.floor(OverTimeWork / (1000 * 60)) % 60;
      const hour = Math.floor(OverTimeWork / (1000 * 60 * 60))



      if (punchInTime) {
        setisPunchedIn(response.data?.data?.isPunchIn);
        setisPunchedOut(response.data?.data?.isPunchOut);

        if (response.data?.data.punchIn && response.data?.data?.punchOut) {
          setOverTime(`${hour} hours, ${minute} minutes, ${second} seconds`)
        }

        if (response.data?.data?.isPunchIn && !response.data?.data?.isPunchOut) {
          if (timeDiff <= 0) {
            setShowRemainingTime(false);
          } else {
            setRemainingTime(`${hours} hours, ${minutes} minutes, and ${seconds} seconds`);
            setShowRemainingTime(true);
          }
        }

        if (response.data?.data?.isPunchIn && response.data?.data?.isPunchOut) {
          setWorkTime(calculateTimeDifference(punchInTime, punchOutTime));
        }
      } else {
        console.log('User has not punched in today.');
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    TodayPunchedIn()
  }, [])

  const todayPunch = moment(isUserPunchedIn).startOf('hour').fromNow()

  const [weeklyPunched, setWeeklyPunched] = useState([])

  const AllAttendance = async () => {
    try {
      const id = JSON.parse(sessionStorage.getItem('user'))?.id;

      const response = await axios.get(`${Api_Url}api/v1/Attendance?PageNumber=1&PageSize=1000`);
      const allAttendanceData = response.data?.data;


      const filteredData = allAttendanceData.filter((res) => (res.userProfileId === id));

      setWeeklyPunched(filteredData);
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    AllAttendance()
  }, [])


  const [ActivityData, setActivityData] = useState([])

  const AllActivityFetch = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem('user'))?.id
      const response = await axios.get(`${Api_Url}api/v1/ActivityLog/myself?UserId=${userId}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
        }
      })
      // console.log("response", response.data.data.activityList)
      // setData(response.data?.data?.activityList)
      setActivityData(response.data?.data?.activityCount)
      FetchImage()
    } catch (error) {
      return error.message
    }
  }

  useEffect(() => {
    AllActivityFetch()
  }, [])



  return (
    <>

      <div className="page-wrapper">
        <div className="content container-fluid pb-0">

          <div className="row">
            <div className="col-md-12">
              <div className="employee-alert-box">
              
              </div>
            </div>
          </div>


          <div className="row" style={{ height: "max-content" }}>

            <div className="col-xl-6 col-md-12 d-flex flex-column">
              <div className="card employee-month-card ">
                <div className="card-body">

                  <div className="employee-month-details">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5>Welcome</h5>
                    <img src={Applogo} alt="roha housing"/>
                    </div>
                    <p>
                      "{dailyQuote.quote}"
                    </p>
                    {/* <h5 className="text-end" style={{ fontStyle: 'italic' }}>{dailyQuote.writer}</h5> */}

                  </div>
                </div>


              </div>

              <div className="card flex-fill">
                <div className="card-body">
                  <div className="statistic-header">
                    <h4>Activity Dashboard</h4>
                    <div className="dropdown statistic-dropdown">
                      <Link
                        className="dropdown-toggle"
                        data-bs-toggle="dropdown"
                        to="#"
                      >
                        Today
                      </Link>
                      <div className="dropdown-menu dropdown-menu-end">
                        <Link to="#" className="dropdown-item">
                          Week
                        </Link>
                        <Link to="#" className="dropdown-item">
                          Month
                        </Link>
                        <Link to="#" className="dropdown-item">
                          Year
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="activity-list">
                    {ActivityData && ActivityData.length > 0 && ActivityData.map((response) => {
                      return (
                        <div className="col-6 col-md-3 activity-item" key={response.id}>
                          <div className="attendance-details" title={response?.name}>
                            <h4 className="text-primary">{response?.count}</h4>
                            <p className="text-ellipsis">{response?.name}</p>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>


            </div>
            <div className="col-lg-6 col-md-12">
              <div className="card employee-welcome-card flex-fill">
                <div className="card-body">
                  <div className="welcome-info">
                    <div className="welcome-content">
                      <h4>Welcome Back, {name}</h4>

                    </div>
                    <div className="welcome-img">
                      <img
                        src={userProfileImage?.profileImageUrl ? userProfileImage?.profileImageUrl : AllFormsUpperphoto}
                        className="img-fluid"
                        alt="User"
                      />
                    </div>
                  </div>
                  <div className="welcome-btn">
                    <Link to="/profile" className="btn">
                      View Profile
                    </Link>
                  </div>
                </div>
              </div>

              <div className="card flex-fill">
                <div className="card-body">
                  <div className="statistic-header">
                    <h4>Attendance Statistics</h4>
                    <div className="dropdown statistic-dropdown">
                      <Link
                        className="dropdown-toggle"
                        data-bs-toggle="dropdown"
                        to="#"
                      >
                        Today
                      </Link>
                      <div className="dropdown-menu dropdown-menu-end">
                        <Link to="#" className="dropdown-item">
                          Week
                        </Link>
                        <Link to="#" className="dropdown-item">
                          Month
                        </Link>
                        <Link to="#" className="dropdown-item">
                          Year
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="clock-in-info">
                    <div className="clock-in-content">
                      {/* <p>Work Time</p> */}
                      <div>
                        {!isPunchedIn && !isPunchedOut && (
                          <p>User has not punched in yet.</p>
                        )}
                        {isPunchedIn && !isPunchedOut && (
                          <h4><p>{todayPunch}</p></h4>
                        )}
                        {isPunchedIn && isPunchedOut && (
                          <h4>Work Time: <p>{workTime}</p></h4>
                        )}
                      </div>
                    </div>
                    <div className="clock-in-btn">
                      {!(isPunchedIn && isPunchedOut) && (
                        <Link to="#" className="btn btn-primary" onClick={HandlePunchIn}>
                          <img src={clockin} alt="Icon" />{" "}
                          {isPunchedIn ? 'Punch Out' : 'Punch In'}
                        </Link>
                      )}
                    </div>
                  </div>
                  <div className="clock-in-list">
                    <ul className="nav">
                      <li>
                        <h6>{remainingTime ? (`Remaining Time: ${remainingTime}`) : (null)}</h6>
                      </li>
                      <li>

                        <h6>{isPunchedIn && isPunchedOut &&
                          <h4>Overtime: {overtime}</h4>
                        }
                        </h6>
                      </li>
                      <li>
                        <p>Break</p>
                        <h6>1 Hrs 00 Min</h6>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>

    </>

  );
};

export default EmployeeDashboard;




